import React from 'react';
import { createPortal } from 'react-dom';

const ConfirmModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = 'Confirm Action',
    message,
    confirmText = 'Confirm',
    cancelText = null, // null means show only confirm button (alert style)
    variant = 'danger' // 'danger' or 'primary'
}) => {
    if (!isOpen) return null;

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    const confirmButtonClass = variant === 'danger'
        ? 'bg-red-600 hover:bg-red-700'
        : 'bg-blue-600 hover:bg-blue-700';

    const isAlert = cancelText === null;

    return createPortal(
        <div className="fixed inset-0 bg-black/50 z-[10000] flex items-center justify-center p-4" data-modal="true">
            <div className="bg-[var(--surface-bg)] rounded-lg w-full max-w-md shadow-xl" data-modal="true">
                {/* Header */}
                <div className="p-4 border-b border-[var(--surface-border)]">
                    <h2 className="text-lg font-semibold text-[var(--text-primary)]">
                        {title}
                    </h2>
                </div>

                {/* Content */}
                <div className="p-4">
                    <p className="text-[var(--text-primary)]">{message}</p>
                </div>

                {/* Footer */}
                <div className={`flex gap-2 p-4 border-t border-[var(--surface-border)] ${isAlert ? 'justify-center' : 'justify-end'}`}>
                    {!isAlert && (
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-[var(--surface-bg)] text-[var(--text-primary)] rounded-md hover:bg-[var(--button-hover-bg)] transition-colors border border-[var(--input-border)]"
                        >
                            {cancelText}
                        </button>
                    )}
                    <button
                        onClick={handleConfirm}
                        className={`px-4 py-2 text-white rounded-md transition-colors ${confirmButtonClass}`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ConfirmModal;

